export default __webpack_public_path__ + "media/images/react_icons/property/linen_towels-4af57c8a00486e07a4c1dbe5de5a916b.svg";